"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = function () {
  var d = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  var date = new Date(d);
  date.setHours(0, 0, 0, 0);
  return date;
};